module.exports = "<wow-card-list show-header=\"true\">\r\n    <wow-search-list is-special=\"true\"></wow-search-list>\r\n</wow-card-list>"


/*****************
 ** WEBPACK FOOTER
 ** ./wowapp/src/shop/components/search/search-specials-center-template.html
 ** module id = 997
 ** module chunks = 1
 **/